import { Referential, ReferentialData } from '@core/models/referential.model';

export class ReferentialHelper {
  private static referential: Array<Referential> = [];
  private static referentialMap: { [key: string]: Array<ReferentialData> } = {};

  public static initReferential(refs: Array<Referential>): void {
    ReferentialHelper.referential = refs;
    refs.forEach(ref => {
      ReferentialHelper.referentialMap[ref.id] = ref.values;
    });
  }

  public static getReferential(id: string): Array<ReferentialData> {
    return ReferentialHelper.referentialMap[id];
  }
}
